import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BankAccountsStore } from '../store/bank-accounts.store';
import { BankAccountStatus } from '../store/types';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Guard que protege las rutas de operaciones cuando la cuenta seleccionada está suspendida.
 * Bloquea el acceso a transferencias y solicitudes de pago si la cuenta tiene status SUSPENDED.
 */
export const accountNotSuspendedGuard: CanActivateFn = (route, state) => {
  const bankAccountsStore = inject(BankAccountsStore);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const selectedAccount = bankAccountsStore.selectedBankAccount();

  if (selectedAccount?.status === BankAccountStatus.SUSPENDED) {
    snackBar.open(
      'La cuenta seleccionada está suspendida; no puede realizar esta acción por el momento.',
      'Entendido',
      {
        duration: 5000,
        panelClass: ['mat-snack-error'],
        horizontalPosition: 'center',
        verticalPosition: 'top'
      }
    );

    router.navigate(['/']);
    return false;
  }

  return true;
};
